import { useLocation } from '@xing-com/crate-core-router';

export const useIsWebview = () => {
  const location = useLocation();

  const isWebview = location.pathname.startsWith('/pages/webview');

  return isWebview;
};
